"use client";

import { c as _c } from "react/compiler-runtime";
import { EventCard } from "./event-card";
import { useParams } from "next/navigation";
import { useSuspenseQuery } from "@apollo/client/react";
import { GET_EVENTS } from "@/graphql/queries/event-query";
import { RenderIf } from "./render-if";
import { CustomPagination } from "./pagination";
import EmptyEvent from "./empty-event";
import { EventFiltersType } from "./event-filters";
import { Suspense } from "react";
import { StructuredData } from "./structured-data";
import useEventSchema from "@/hooks/use-event-schema";
type EventsProps = {
  countryCode?: string;
  filters: EventFiltersType;
  page: number;
  perPage: number;
};
type Params = {
  course: string;
  country?: string;
  city?: string;
};
const Events = t0 => {
  const $ = _c(25);
  const {
    countryCode,
    filters,
    page,
    perPage
  } = t0;
  const {
    course,
    country,
    city
  } = useParams();
  const t1 = country ? country : countryCode ? countryCode : "us";
  let t2;
  if ($[0] !== city || $[1] !== course || $[2] !== filters || $[3] !== page || $[4] !== perPage || $[5] !== t1) {
    t2 = {
      variables: {
        slug: course,
        country: t1,
        city,
        perPage,
        page,
        ...filters
      }
    };
    $[0] = city;
    $[1] = course;
    $[2] = filters;
    $[3] = page;
    $[4] = perPage;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    data
  } = useSuspenseQuery(GET_EVENTS, t2);
  let t3;
  if ($[7] !== data?.events?.data) {
    t3 = data?.events?.data ?? [];
    $[7] = data?.events?.data;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const events = t3;
  const pageInfo = data?.events?.pageInfo;
  const eventSchema = useEventSchema(events);
  const t4 = events.length > 0;
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <EmptyEvent />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== events) {
    t6 = events.map(_temp);
    $[10] = events;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <RenderIf condition={t4} fallback={t5}>{t6}</RenderIf>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  const t8 = pageInfo?.currentPage;
  const t9 = pageInfo?.lastPage;
  const t10 = pageInfo?.total;
  let t11;
  if ($[15] !== t10 || $[16] !== t8 || $[17] !== t9) {
    t11 = <Suspense><CustomPagination currentPage={t8} totalPages={t9} totalItems={t10} /></Suspense>;
    $[15] = t10;
    $[16] = t8;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== eventSchema) {
    t12 = eventSchema.length > 0 && <StructuredData data={eventSchema} />;
    $[19] = eventSchema;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== t11 || $[22] !== t12 || $[23] !== t7) {
    t13 = <div className="space-y-4">{t7}{t11}{t12}</div>;
    $[21] = t11;
    $[22] = t12;
    $[23] = t7;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  return t13;
};
export default Events;
function _temp(item) {
  return <EventCard key={item.id} data={item} />;
}